const tableHeader = [
  {
    title: 'biller_enrollment_list.header.enrollment_confirmation_number',
  },
  {
    title: 'biller_enrollment_list.header.enrollment_date',
  },
  {
    title: 'biller_enrollment_list.header.biller',
  },
  {
    title: 'biller_enrollment_list.header.reference_number',
  },
  {
    title: 'biller_enrollment_list.header.wallet_id',
  },
  {
    title: 'biller_enrollment_list.header.full_name',
  },
  {
    title: 'biller_enrollment_list.header.email_address',
  },
  {
    title: 'biller_enrollment_list.header.mobile_number',
  },
  {
    title: 'biller_enrollment_list.header.enrollment_type',
  },
  {
    title: 'biller_enrollment_list.header.enrollment_status',
  },
];

export default tableHeader;
